class RetainedValuesUtils {
	populateRetainedValues(record, values) {
		values.forEach((r) => {
			r.value.forEach((v) => {
				record[v.key] = v.value;
			});
		});
		return record;
	}
}
const retainedValuesUtils = new RetainedValuesUtils();
export default retainedValuesUtils;
